import { fatal } from "../logging/fatal";
import { BrowserUtil } from "../utils/BrowserUtil";

import { Capabilities, URLRequest } from "@goodgamestudios/createjs-utilities";
import { BasicConstants } from "../basic/constants/BasicConstants";

//import URLRequestMethod = createjs.URLRequestMethod;

/**
 * class to call goodgame-support-form
 *
 * @author dkoehler
 */
export class SupportUtil {
    /** url to support form . */
    public static GGS_SUPPORT_URL: string = BasicConstants.DOMAIN_PROTOCOL + "://support.goodgamestudios.com/";

    private static supportData: ASupportData;

    /**
     * call support-form with specific game parameters
     *
     * @param instanceId
     * @param versionText
     * @param userName userName of current client user
     * @param playerId playerId of current client user
     * @param userId userid of current client user
     * @param language selected game language of user
     */
    public static navigateToSupport(instanceId: number, versionText: string, userName: string, playerId: number, userId: number, language: string): void {
        try {
            let urlRequest: URLRequest = new URLRequest(SupportUtil.GGS_SUPPORT_URL);
            SupportUtil.supportData.versionText = versionText;
            let vars: any = SupportUtil.supportData.createUrlVars(instanceId, userName, playerId, userId, language);
            urlRequest.data = vars;
            BrowserUtil.executeNavigateToURL(urlRequest, "_blank");
        }
        catch (e) {
            fatal("cannot navigate to support form");
        }
    }

    /**
     * creates WebSupportData with Web specific data
     *
     * @param referrer who calls this game
     * @param gameId
     * @param sessionId
     * @param networkId
     * @param playerVersion
     * @param os
     *
     */
    public static initForWeb(referrer: string, gameId: number, sessionId: string, networkId: number, playerVersion: string, os: string): void {
        SupportUtil.supportData = new WebSupportData(referrer, gameId, sessionId, networkId, playerVersion, os);
    }

    /**
     * creates MobileSupportData with Mobile specific data
     *
     * @param gameId
     * @param sessionId
     * @param networkId
     * @param sourceStore
     * @param deviceType
     * @param os
     *
     */
    public static initForMobile(gameId: number, sessionId: string, networkId: number, sourceStore: string, deviceType: string, os: string): void {
        SupportUtil.supportData = new MobileSupportData(gameId, sessionId, networkId, sourceStore, deviceType, os);
    }
}

/**
 * abstract class to generate data field
 */
export class ASupportData {
    private _gameId: number;
    private _sessionId: string;
    private _networkId: number;
    private _versionText: string;
    private _os: string;

    constructor(gameId: number, sessionId: string, networkId: number, os: string) {
        this.gameId = gameId;
        this.sessionId = sessionId;
        this.networkId = networkId;
        this.os = os;
    }

    public createUrlVars(instanceId: number, userName: string, playerId: number, userId: number, language: string): any {
        let vars: any = {};
        vars["g"] = this.gameId;
        vars["n"] = this.networkId;
        vars["i"] = instanceId;
        vars["sid"] = this.sessionId;
        vars["pid"] = playerId;
        vars["uid"] = userId;
        vars["lang"] = language;
        vars["uname"] = userName;
        vars["data"] = toString();
        return vars;
    }

    public toString(): string {
        return "";
    }

    public get gameId(): number {
        return this._gameId;
    }

    public set gameId(value: number) {
        this._gameId = value;
    }

    public get sessionId(): string {
        return this._sessionId;
    }

    public set sessionId(value: string) {
        this._sessionId = value;
    }

    public get networkId(): number {
        return this._networkId;
    }

    public set networkId(value: number) {
        this._networkId = value;
    }

    public get versionText(): string {
        return this._versionText;
    }

    public set versionText(value: string) {
        this._versionText = value;
    }

    public get os(): string {
        return this._os;
    }

    public set os(value: string) {
        this._os = value;
    }
}

/**
 * class to generate web specific data field
 */
export class WebSupportData extends ASupportData {
    private _referrer: string;
    private _playerVersion: string;

    constructor(referrer: string, gameId: number, sessionId: string, networkId: number, playerVersion: string, os: string) {
        super(gameId, sessionId, networkId, os);
        this.referrer = referrer;
        this.playerVersion = playerVersion;
    }

    public createUrlVars(instanceId: number, userName: string, playerId: number, userId: number, language: string): any {
        let vars: any = super.createUrlVars(instanceId, userName, playerId, userId, language);
        vars["ref"] = this.referrer;
        return vars;
    }

    public toString(): string {
        let data: string = super.toString();
        data += "Game-Version: " + this.versionText + "\n" + "Flash Player - Version:" + this.playerVersion + "\n" + "OS:" + Capabilities.os;

        return data;
    }

    public get referrer(): string {
        return this._referrer;
    }

    public set referrer(value: string) {
        this._referrer = value;
    }

    public get playerVersion(): string {
        return this._playerVersion;
    }

    public set playerVersion(value: string) {
        this._playerVersion = value;
    }
}

/**
 * class to generate mobile specific data field
 */
export class MobileSupportData extends ASupportData {
    private _sourceStore: string;
    private _deviceType: string;

    constructor(gameId: number, sessionId: string, networkId: number, sourceStore: string, deviceType: string, os: string) {
        super(gameId, sessionId, networkId, os);

        this.sourceStore = sourceStore;
        this.deviceType = deviceType;
    }

    public toString(): string {
        return super.toString();
    }

    public get sourceStore(): string {
        return this._sourceStore;
    }

    public set sourceStore(value: string) {
        this._sourceStore = value;
    }

    public get deviceType(): string {
        return this._deviceType;
    }

    public set deviceType(value: string) {
        this._deviceType = value;
    }
}
